module.exports = __webpack_public_path__ + "img/loan_img_3.b942c0eb.png";